import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { removeCaracter } from 'src/app/core/constants/properties-const';
import { AutocompleteLead, Campaign, Checked, Matched } from 'src/app/core/models/lead-campaign';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { ButtonsPopupService } from 'src/app/shared/components/buttons-popup/service/buttons-popup.service';
import { LoginService } from 'lps-navigation';
import { LeadCampaignService } from '../lead-campaign.service';
import { first } from 'rxjs/operators';
import { FeatureToggleService } from 'src/app/core/toggle/feature-toggle.service';

@Component({
  selector: 'app-modal-participate',
  templateUrl: './modal-participate.component.html',
  styleUrls: ['./modal-participate.component.scss']
})
export class ModalParticipateComponent implements OnInit {

  @Output() public closeParticipants = new EventEmitter<boolean>();
  @Output() public finished = new EventEmitter<boolean>();

  @Input() public isParticipate = false;
  @Input() public campaign: Campaign;

  public removeCaracter = removeCaracter;
  public isSummary = false;
  public is_price = false;
  public index = null;

  public minValue = 500;
  public maxParticipants = 5;
  public isError = false;
  public messageErro = 'Ajuste os percentuais para totalizar 100%';
  public isValueError = false;
  public valueErro = 'O somatório dos participantes deve ser igual ao total investido';
  public participantFieldError = [];
  public form: FormGroup;
  public isCustomSub: boolean;
  public isSegmentationAvailable: boolean;

  public listRadioButton = [
    {
      id: 1,
      title: 'Prefiro que a Lopes escolha por mim',
      value: 'CHOOSE'
    },
    {
      id: 2,
      title: 'Segmentação nativa: prioriza um volume alto de leads a um custo por lead baixo',
      value: 'NATIVE'
    },
    {
      id: 3,
      title: 'Segmentação inteligente Lopes: traz leads mais qualificados, em menor quantidade, com um custo por lead mais alto',
      value: 'INTELLIGENT'
    }
  ];

  public deleteUser = {
    title: 'ATENÇÃO!',
    description: 'Tem certeza que deseja excluir o participante dessa campanha?',
    buttons: [
      {
        btnType: 0,
        title: 'Cancelar',
        func: () => null,
      },
      {
        btnType: 2,
        title: 'Excluir',
        func: () => this.clearParticipate(),
      }
    ]
  };

  public porcentNotFound = {
    title: 'ATENÇÃO!',
    description: 'O percentual entre todos os participantes precisa totalizar 100%.',
    buttons: [
      {
        btnType: 0,
        title: 'Ok',
        func: () => null,
      }
    ]
  };

  public valueNotFound = {
    title: 'ATENÇÃO!',
    description: 'O valor investido entre todos os participantes precisa totalizar o montante investido.',
    buttons: [
      {
        btnType: 0,
        title: 'Ok',
        func: () => null,
      }
    ]
  };

  public processCancel = {
    title: 'ATENÇÃO!',
    description: 'Tem certeza que deseja cancelar?',
    buttons: [
      {
        btnType: 0,
        title: 'Cancelar',
        func: () => null,
      },
      {
        btnType: 2,
        title: 'OK',
        func: () => this.closeFullModal(),
      }
    ]
  };

  public minParticipantValue = () => {
    return {
      title: 'ATENÇÃO!',
      description: `O valor mínimo para essa campanha é de 
      ${this.minValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`,
      buttons: [
        {
          btnType: 0,
          title: 'OK',
          func: () => null,
        }
      ]
    }
  };

  get participants() {
    return this.form.get('participants') as FormArray;
  }

  get valueInvest() {
    return this.form.get('value_invest') as FormArray;
  }

  public selectedStatus: Checked = this.listRadioButton[0];


  constructor(
    private fb: FormBuilder,
    private btnsService: ButtonsPopupService,
    private scroll: WindowScrollService,
    private campaignService: LeadCampaignService,
    private loginService: LoginService,
    private featureToggleService: FeatureToggleService
  ) { }


  ngOnInit(): void {
    this.initialize();
    this.newParticipate();
    this.findNavigation();
    this.validatoForm();
    this.checkToggles();
    this.loadSubSettings();
  }

  private jwtToken(): any {
    return this.loginService.getPayloadToken(this.loginService.getAuthInformation().token);
  }

  private findNavigation(): void  {
    const nickname = this.jwtToken().nickname;
    this.campaignService.getParticipantsAutoComplete(nickname)
    .pipe(first())
    .subscribe((result) => {
      const user = result.find(person => person.matched_record.nickname === nickname);
      if (user) this.getUser(user, 0);
    });
  }

  private initialize(): void {
    this.form = this.fb.group({
      id: [this.campaign.id],
      name: [this.campaign.name],
      product_name: [this.campaign.product_name],
      product_image_url: [this.campaign.product_image_url],
      sku: [this.campaign.product_sku],
      subscription: [this.campaign.subscription],
      validity: [this.campaign.duration],
      value_invest: [null, Validators.required],
      participants: this.fb.array([]), // TODO: setar participantes já inseridos na campanha
      type_segmentation: [this.selectedStatus, Validators.required],
      campaign_group: [this.campaign.campaign_group]
    });
  }

  private checkToggles() {
    this.isCustomSub = this.featureToggleService.isActive('toggle_lopes_lead_custom_subscription');
    this.isSegmentationAvailable = this.featureToggleService.isActive('toggle_lopes_lead_segmentation_available');
  }

  private loadSubSettings() {
    const group = this.campaign.campaign_group;
    if (this.isCustomSub && group.max_realtor) {
      this.minValue = group.min_value;
      this.maxParticipants = group.max_realtor;
    }
  }

  public closeModal(): void {
    this.btnsService.show(this.processCancel);
  }

  public AddUser(data?: Matched, value?: number): FormGroup {
    return this.fb.group({
      user_id: [data?.id ? data.id : '', Validators.required],
      user_name: [data?.name ? data.name : '', Validators.required],
      user_nickname: [data?.nickname ? data.nickname : '', Validators.required],
      participation_value: [value, Validators.required],
      participation_percentage: [value, Validators.required],
      picture_url: [''],
      leaders: [null]
    });
  }

  public newParticipate(): void {
    if (this.participants.length >= this.maxParticipants) {
      return;
    }
    this.participants.push(this.AddUser());
  }

  public showDialog(index: number): void {
    this.index = index;
    this.btnsService.show(this.deleteUser);
  }

  public showMinValueDialog() {
    this.btnsService.show(this.minParticipantValue());
  }

  public clearParticipate(): void {
    this.participants.removeAt(this.index);
  }

  /**
   * It will calculate the total value of the prop passed on the participants form.
   * @param obj Participants form data
   * @param prop E.g 'participation_percentage' || 'participation_value'
   * @param type E.g 'float' || 'currency'
   * @returns The total value in the $type format (e.g 1000.32 || 1.000,32)
   */
  public getTotalFromProp(obj: any, prop: string, type: string): number {
    const typesRule = {
      float: () => obj.reduce((total: number, value: any) => total + parseFloat(value[prop]), 0),
      currency: () => obj.reduce((total: number, value: any) => total + this.parseCurrency(value[prop]), 0)
    }
    return typesRule[type] && typesRule[type]();
  }

  /**
   * The validate logic used in every input change in the form.
   * @param participant Participants form data
   */
  public validateLogic(participant: any): void {
    this.participantFieldError = [];
    this.isError = false;
    this.isValueError = false;
    
    const participationPercentage =  this.getTotalFromProp(
      participant, 'participation_percentage', 'float'
    );

    const participationValue = this.getTotalFromProp(
      participant, 'participation_value', 'currency'
    );

    const valueInvest = Math.abs(this.parseCurrency(this.form.get('value_invest').value));

    if (Math.ceil(participationPercentage) != 100 &&
        Math.floor(participationPercentage) != 100 &&
        participationPercentage != 100) {
      this.isError = true;
      return;
    }
    if (participationValue != valueInvest) {
      this.isValueError = true;
    }
  }

  /**
   * It will subscribe the valueChanges in both participants and valueInvest form.
   */
  public validatoForm(): void {
    this.participants.valueChanges.subscribe(part => {
      this.validateLogic(part);   
      this.valueInvest.valueChanges.subscribe(_ => {
        this.validateLogic(part);
      })
    });
  }

  /**
   * It will update the participation_value (if it don't exist) or 
   * the participation_percentage (if already have a participation_value) 
   * from each participant based on the total invested value.
   * @param valueInvest The total invested value.
   */
  public updateAllValues(valueInvest: string): void {
    this.participants.value.forEach((part, i) => {
      if (!part.participation_value) {
        this.participants.controls[i].get('participation_value').setValue(
          this.getValueOrPercentage(
            this.parseCurrency(valueInvest), 
            part.participation_percentage, 
            'currency'
            )
        );
        return;
      }

      this.participants.controls[i].get('participation_percentage').setValue(
        this.getValueOrPercentage(
          this.parseCurrency(part.participation_value), 
          this.parseCurrency(valueInvest), 
          'percentage'
          )
      );
    });
  }

  /**
   * It will parse the string number into the currency format.
   * @param value String value (e.g '1.350,32').
   * @returns If valid string will return a parsed number (e.g 1350.32) or null if not valid.
   */
  public parseCurrency(value: string): number {
    try {
      return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    } catch (error) {
      return null;
    }
  }

  /**
   * It will calculate the partial percentage from the total invested or the partial value 
   * from the total invested.
   * @param value Pass the participation_value if want to know the percentage or the 
   * totalInvest if want to know the value. 
   * @param totalOrPercent Pass the totalInvest if want to know the percentage or the 
   * participation_percentage if want to know the value.
   * @param type If not passed will return the currency logic parse in number 
   * (e.g 'percentage' || 'currency').
   * @returns 
   */
  public getValueOrPercentage(value: number, totalOrPercent: number, type: string = 'value'): any {
    const typesRule = {
      percentage: () => (value * 100 / totalOrPercent).toFixed(2),
      currency: () => (totalOrPercent / 100 * value).toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
      default: () => Number((totalOrPercent / 100 * value).toFixed(2))
    }
    return typesRule[type] ? typesRule[type]() : typesRule.default();
  }

  /**
   * It will calculate the equivalent percentage or value for a specific participant.
   * @param value The new input value.
   * @param index Participant index.
   * @param type E.g 'participation_percentage' || 'participation_value'.
   */
  public calculateNumbers(value: any, index: number, type: string): void {
    let totalInvest = this.parseCurrency(this.form.get('value_invest').value);
    let realtorInvest = this.parseCurrency(value);

    if (!totalInvest || !realtorInvest) return;
    
    let calc = this.getValueOrPercentage(realtorInvest, totalInvest, 'percentage');
    if (type == 'participation_value') {
      calc = this.getValueOrPercentage(totalInvest, value, 'currency');
    }
    this.participants.controls[index].get(type).setValue(calc);
  }

  public changeValue(data: Checked): void {
    this.selectedStatus = data;
    this.form.get('type_segmentation').setValue(this.selectedStatus);
  }

  public nextLevel(): void {
    this.is_price = false;
    this.isError = false;
    this.isValueError = false;
    
    const valueInvest = parseFloat(this.form.get('value_invest').value.replace('.', '').replace(',', '.'));

    this.participantFieldError = this.participants.getRawValue().map((value) => {
      const participantPercentage = Number(value.participation_percentage);
      const participantValue = this.parseCurrency(value.participation_value);
      const calculatedValue = this.getValueOrPercentage(participantPercentage, valueInvest);
      
      if (valueInvest * (participantPercentage / 100) < 100) {
        return 'O investimento mínimo por participante deve ser de R$ 100.';
      } 
      
      if (Math.ceil(calculatedValue) !== Math.ceil(participantValue) &&
          Math.floor(calculatedValue) !== Math.floor(participantValue) &&
          calculatedValue !== participantValue) {
        return 'O somatório dos participantes deve ser igual ao total investido';
      }

      return null;
    });
    
    if (this.participantFieldError.find(error => error !== null)) {
      return;
    }

    const totalPercentage = this.getTotalFromProp(this.participants.getRawValue(), 'participation_percentage', 'float');
    const totalValue = this.getTotalFromProp(this.participants.getRawValue(), 'participation_value', 'currency');

    if (Math.ceil(totalPercentage) != 100 &&
        Math.floor(totalPercentage) != 100 &&
        totalPercentage != 100) {
      this.isError = true;
      this.btnsService.show(this.porcentNotFound);
      return;
    }

    if (totalValue !== this.parseCurrency(this.form.get('value_invest').value)) {
      this.isValueError = true;
      this.btnsService.show(this.valueNotFound);
      return;
    }

    if (valueInvest < +this.minValue) {
      this.is_price = true;
    } else {
      this.isSummary = true;
    }
  }

  public closeFullModal(): void {
    this.form.reset();
    this.closeParticipants.emit(false);
    this.isParticipate = false;
    this.isSummary = false;
  }

  public backLevel(data: boolean): void {
    this.isSummary = data;
    this.scroll.disable();
  }

  public getUser(user: AutocompleteLead, i: number): void {
    let firstPercentage = this.participants.controls[0].get('participation_percentage')
    if (i === 0 && !firstPercentage.value) {
      firstPercentage.setValue('100');
    }
    this.participants.controls[i].get('user_name').setValue(user?.matched_record?.name);
    this.participants.controls[i].get('user_id').setValue(user?.matched_record?.id);
    this.participants.controls[i].get('user_nickname').setValue(user?.matched_record?.nickname);
    this.participants.controls[i].get('picture_url').setValue(user?.matched_record?.picture_url);
    this.participants.controls[i].get('leaders').setValue(user?.matched_record?.leaders);
  }
}